import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p9 from '../assets/images/so3.gif';
import p10 from '../assets/images/social.gif';
import p11 from '../assets/images/multi.gif';
import p12 from '../assets/images/so.gif';
import p13 from '../assets/images/so1.gif';


const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b> Just a click away to Connect with Friends...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p9} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.facebook.com/" className="btn btn-xl btn-light mr-4">
         Facebook
        </a>
        <a href="https://www.instagram.com/" className="btn btn-xl btn-dark">
        Instagram
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://twitter.com/explore" className="btn btn-xl btn-light mr-4">
        Twitter
        </a>
        <a href="http://www.whatsapp.com/" className="btn btn-xl btn-dark">
         WhatsApp
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.flickr.com/" className="btn btn-xl btn-light mr-4">
          Flickr
        </a>
        <a href="http://linkedin.com/" className="btn btn-xl btn-dark">
          Linkedin
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://cafemom.com/" className="btn btn-xl btn-light mr-4">
          Cafe Mom
        </a>
        <a href="https://www.ravelry.com/account/login" className="btn btn-xl btn-dark">
          Ravelry
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.flixster.com/" className="btn btn-xl btn-light mr-4">
          Flixster
        </a>
        <a href="https://www.care2.com/" className="btn btn-xl btn-dark">
          Care2
        </a>
      </div>
    </section>


 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
           <img className="img-fluid" src={p10} alt="" />
          <h2 className="mb-5">Hey, Everything is connected..<i className="fa fa-share-square fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.skype.com/en/" className="btn btn-xl btn-light mr-4">
         Skype
        </a>
        <a href="http://www.youtube.com/" className="btn btn-xl btn-dark">
        Youtube
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.wechat.com/en/" className="btn btn-xl btn-light mr-4">
         WeChat
        </a>
        <a href="https://www.imqq.com/" className="btn btn-xl btn-dark">
          QQ
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.snapchat.com/" className="btn btn-xl btn-light mr-4">
         Snapchat
        </a>
        <a href="https://line.me/en/" className="btn btn-xl btn-dark">
         Line
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://telegram.org/" className="btn btn-xl btn-light mr-4">
         Telegram
        </a>
        <a href="https://medium.com/" className="btn btn-xl btn-dark">
          Medium
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://nextdoor.com/" className="btn btn-xl btn-light mr-4">
        Next Door
        </a>
        <a href="https://www.wayn.com/" className="btn btn-xl btn-dark">
       Wayn
        </a>
      </div>
    </section>


 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
           <img className="img-fluid" src={p11} alt="" />
          <h2 className="mb-5">Connect with friends..<i className="fa fa-share-square fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.cellufun.com/games.asp?v=3Rpj2MdQV00" className="btn btn-xl btn-light mr-4">
        Cellufun
        </a>
        <a href="https://www.classmates.com/" className="btn btn-xl btn-dark">
       Classmates
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.myheritage.com/" className="btn btn-xl btn-light mr-4">
       My Heritage
        </a>
        <a href="https://viadeo.journaldunet.com/" className="btn btn-xl btn-dark">
       Viadeo
        </a>
      </div>
    </section>






    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.xing.com/" className="btn btn-xl btn-light mr-4">
       Xing
        </a>
        <a href="http://xanga.com/" className="btn btn-xl btn-dark">
       Xanga
        </a>
      </div>
    </section>




    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.livejournal.com/" className="btn btn-xl btn-light mr-4">
        Live Journal
        </a>
        <a href="https://www.funnyordie.com/" className="btn btn-xl btn-dark">
       Funny Ordie
        </a>
      </div>
    </section>






    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.gaiaonline.com/" className="btn btn-xl btn-light mr-4">
        Gaia Online
        </a>
        <a href="https://weheartit.com/" className="btn btn-xl btn-dark">
       We Heart it
        </a>
      </div>
    </section>




<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
           <img className="img-fluid" src={p12} alt="" />
          <h2 className="mb-5">Rule your Social Life Smartly..<i className="fa fa-share-square fa-spin"></i></h2>
        </div>
        
      </div>
    </section>


 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.buzznet.com/?chrome=1" className="btn btn-xl btn-light mr-4">
        Buzznet
        </a>
        <a href="https://www.deviantart.com/" className="btn btn-xl btn-dark">
       Deviant Art
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.meetme.com/#home" className="btn btn-xl btn-light mr-4">
       Meet Me
        </a>
        <a href="https://www.meetup.com/" className="btn btn-xl btn-dark">
       Meet UP
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.tumblr.com/" className="btn btn-xl btn-light mr-4">
        Tumblr
        </a>
        <a href="http://tieba.baidu.com/f/user/passport?jumpUrl=http://tieba.baidu.com" className="btn btn-xl btn-dark">
       Baidu
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.viber.com/en/" className="btn btn-xl btn-light mr-4">
        Viber
        </a>
        <a href="https://weibo.com/overseas" className="btn btn-xl btn-dark">
       Weibo
        </a>
      </div>
    </section>



    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.yy.com/" className="btn btn-xl btn-light mr-4">
        YY
        </a>
        <a href="https://vk.com/" className="btn btn-xl btn-dark">
       Vk
        </a>
      </div>
    </section>




<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
           <img className="img-fluid" src={p13} alt="" />
          <h2 className="mb-5">Connect to the World..<i className="fa fa-share-square fa-spin"></i></h2>
        </div>
        
      </div>
    </section>





 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.pinterest.com/" className="btn btn-xl btn-light mr-4">
        Pinterest
        </a>
        <a href="https://www.reddit.com/" className="btn btn-xl btn-dark">
       Reddit
        </a>
      </div>
    </section>







 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.taringa.net/" className="btn btn-xl btn-light mr-4">
        Taringa
        </a>
        <a href="https://foursquare.com/" className="btn btn-xl btn-dark">
       Foursquare
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.renren.com/" className="btn btn-xl btn-light mr-4">
        Renren
        </a>
        <a href="https://secure.tagged.com/" className="btn btn-xl btn-dark">
       Tagged
        </a>
      </div>
    </section>



 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://badoo.com/" className="btn btn-xl btn-light mr-4">
        Badoo
        </a>
        <a href="https://myspace.com/" className="btn btn-xl btn-dark">
       My Space
        </a>
      </div>
    </section>



     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://mix.com/" className="btn btn-xl btn-light mr-4">
        Mix
        </a>
        <a href="https://www.snapfish.com/home" className="btn btn-xl btn-dark">
       SnapFish
        </a>
      </div>
    </section>




    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
